module.exports = __webpack_public_path__ + "media/images/reseller-page--c294ef9ff06c6e5cb8b9225136e8341b.jpg";